import React, { useState } from "react";
import { BoardStatusBar } from "../components/BoardStatusBar";
import { BoardPicker } from "../components/BoardPicker";
import { LandingOverlay } from "../components/LandingOverlay";
import { removeJWT } from "./auth";
import type { BoardState } from "./useBoardState";

export function SyntrofiUI({ board }: { board: BoardState }) {
  const { currentUser, isGuestBoard } = board;
  // Skip landing if arriving via a share link - the link itself is the entry point
  const hasShareLink = window.location.hash.startsWith("#json=");
  const [anonDismissed, setAnonDismissed] = useState(hasShareLink);

  const handleLogout = () => {
    removeJWT();
    window.location.href = "/auth/logout";
  };

  return (
    <>
      {!currentUser && !anonDismissed && (
        <LandingOverlay onContinueAnon={() => setAnonDismissed(true)} />
      )}
      <BoardStatusBar
        title={board.boardTitle ?? "New board"}
        dirty={board.dirty}
        savedAt={board.savedAt}
        saveType={board.saveType}
        canRename={!isGuestBoard && currentUser !== null}
        theme={board.boardTheme}
        onRename={board.onRename}
        onSave={board.onSave}
        currentUser={currentUser}
        isGuestBoard={isGuestBoard}
        onSaveCopy={board.onSaveCopy}
        onLogout={handleLogout}
      />
      {board.showBoardPicker && (
        <BoardPicker
          onClose={board.onCloseBoardPicker}
          onSelect={board.onSelectBoard}
          onRestore={board.onRestoreCheckpoint}
          currentBoardId={board.currentBoardId}
          onDeletedCurrentBoard={board.onDeletedCurrentBoard}
          onToggleShared={board.onToggleShared}
          onImportFile={board.onImportFile}
          currentUserLogin={currentUser?.login ?? null}
        />
      )}
    </>
  );
}
